import type { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  name: 'production',
  website_url: 'https://www.datanyze.com',
  platform_url: 'https://app.datanyze.com',
  identity_backend_url: 'https://api.datanyze.com/identity',
  backend_domain: 'https://api.datanyze.com',
  images_url: 'https://assets.datanyze.com/images',
  icons_url: 'https://assets.datanyze.com/icons',
  stripe_backend_url: 'https://api.datanyze.com/stripe',
  payment_providers_backend_url: 'https://api.datanyze.com/payment-providers',
  payment_backend_url: 'https://api.datanyze.com/payment',
  config_backend_url: 'https://api.datanyze.com/config',
  GOOGLE_TAG_MANAGER_ID: 'GTM-MQCTMBN',
  SALESFORCE_CAMP_ID: {
    goTo_signup: '7013p000001NlK7AAK',
  },
  auth_cookie: 'dn-tk',
  deviceId_cookie: 'deviceId',
  verification_id_cookie: 'dn-verification-id',

  // Constants moved from ConstantsService
  DATANYZE_COOKIE_DOMAIN: '.datanyze.com',
  GOOGLE_ANALYTIC_SECTION: 'website',
  SF_CAMP_ID: 'camp_id',
  REDIRECT_KEY: 'redirect',
  SKIPCAPTCHA_KEY: 'skipcaptcha',
  GA_COOKIE_FETCH_RETRIES: 3,
  GTM_COOKIE_NAME: '_ga',
  GA_COOKIE_FETCH_INTERVAL: 2000,
  GOOGLE_OPTIMIZE_SCRIPT: 'https://www.googleoptimize.com/optimize.js?id=OPT-K5F7LKW',
  COOKIE_CONSENT_COOKIE_NAME: 'CookieConsent',
  RANDOM_ID_KEY: 'user-session-id',
};
